import {
  AfterViewInit,
  Component, ElementRef,
  EventEmitter,
  HostListener, Inject,
  Input, OnChanges,
  OnDestroy, OnInit, Output, ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DateTimeHelper } from '../../../../helper/date-time.helper';
import { DATA_TRANSFER_HELPER } from "../../../../helper/dataTransfer.helper";
import { DateTimeComponent } from '../../../shared-module/date-pickers/date-time/date-time.component';

@Component({
  selector: 'fi-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
  standalone: false,
})
export class DateFilterComponent implements OnDestroy, AfterViewInit, OnInit, OnChanges {

  @Input() range: Date[];
  @Input() showSelectedRange = true;
  @Input() showSelectedRangeOnMobile = false;
  @Input() rangeDisplayFormat: 'full' | 'short' = 'full';
  @Output() dateRangeSelected = new EventEmitter<Date[]>();
  @ViewChild('calendar') calendar: DateTimeComponent;
  @ViewChild('dropdown') dropdown: ElementRef<HTMLElement>;

  maxRotateWidth = 1100;

  isRotateScreen = false;
  private dropdownIsOpened = false;

  get isOpened(): boolean {
    return this.dropdownIsOpened;
  }
  set isOpened(val: boolean) {
    this.dropdownIsOpened = val;

    if (this.dropdownIsOpened) {
      if (window.innerWidth <= 880 && !this.isInsideMobileFilterOverlay) {
        document.body.style.overflow = 'hidden';
        const offset = this.dropdown.nativeElement.getBoundingClientRect().top - 152;
        window.scroll({top: window.scrollY + offset, behavior: 'smooth'})
      }

    } else {
      document.body.style.overflow = '';
    }
  }

  static isActiveSearch = false;
  isActive = false;
  containerStyle = {};
  private transferSubscription: any;

  constructor(
    private router: Router,
    @Inject(DATA_TRANSFER_HELPER) private dataTransfer
  ) {
    this.isActive = DateFilterComponent.isActiveSearch;
  }

  ngOnChanges(): void {
    if (!this.transferSubscription) {
      this.transferSubscription = this.dataTransfer.transfer.subscribe(e => {
        DateFilterComponent.isActiveSearch = e;
        this.isActive = DateFilterComponent.isActiveSearch;
      })
    }
  }

  deleteDate(): void {
    this.calendar.delete();
  }

  ngOnInit(): void {
    if (window.innerWidth <= this.maxRotateWidth) {
      this.isRotateScreen = window.innerHeight < window.innerWidth;
    }

    this.calculateContainerStyle();
  }

  @HostListener('window:click', [])
  onclick(): void {
    if (this.isOpened && this.calendar.active === true) {
      if (this.isMobile) {
        this.isOpened = false;
        return;
      }

      this.isOpened = false;
      this.calendar.toggleCalendar();
    } else {
      if (this.isOpened) {
        this.isOpened = false;
      }
    }
  }

  @HostListener('window:resize', [])
  calculateContainerStyle(): void {
    if (!this.isMobile) {
      this.containerStyle = {};
      return;
    }

    const maxWidth = 550;
    const maxHeight = 400;
    const ratio = maxWidth / maxHeight;

    let width = Math.min(window.innerWidth, maxWidth - 20);
    let height = Math.min(window.innerHeight, maxHeight - 20);


    if (width > height * ratio) {
      width = height * ratio;
    } else if (height > width / ratio) {
      height = width / ratio;
    }

    if (window.innerWidth <= 880) {
      this.containerStyle = {
        position: 'fixed',
        left: `15px`,
        right: `20px`,
        top: `192px`,
      }
    } else {
      this.containerStyle = {
        left: `${(window.innerWidth - width) / 2 + 10}px`,
        right: `${(window.innerWidth - width) / 2 + 10}px`,
        top: `${(window.innerHeight - height) / (this.isMobile ? 6 : 2) + 10}px`,
      }
    }
  }

  ngAfterViewInit(): void {
  }


  ngOnDestroy(): void {
  }

  get isMobile(): boolean {
    if (window.innerWidth <= 880) {
      return true;
    }
    return false;
  }

  private get isInsideMobileFilterOverlay(): boolean {
    return !!this.dropdown?.nativeElement?.closest('.mobile-filter-overlay');
  }

  get rangeText(): string {
    if (this.range && this.range[0] && this.range[1]) {
      return this.range.map(date => this.formatDateLabel(date)).join(' - ');
    }

    return '';
  }

  closeOverlay($event): void {
    $event.stopPropagation();
    this.isOpened = false;
  }

  onRangeSelect(range: Date[]): void {
    this.dateRangeSelected.emit(range);

    setTimeout(() => {
      if (this.calendar.active) {
        this.calendar.toggleCalendar();
      }

      this.isOpened = false;
    }, 200);
  }

  toggleCalendar(): void {
    setTimeout(() => {
      this.isOpened = !this.isOpened; this.calendar.toggleCalendar();
    }, 50);
  }

  get hasSelectedRange(): boolean {
    return !!(this.range?.length >= 2 && this.range[0] && this.range[1]);
  }

  get shouldShowSelectedRange(): boolean {
    return this.hasSelectedRange && this.showSelectedRange && (!this.isMobile || this.showSelectedRangeOnMobile);
  }

  private formatDateLabel(date: Date): string {
    const normalizedDate = new Date(date);
    const day = `${normalizedDate.getDate()}`.padStart(2, '0');
    const month = `${normalizedDate.getMonth() + 1}`.padStart(2, '0');

    if (this.rangeDisplayFormat === 'short') {
      return `${day}.${month}.`;
    }

    return `${day}.${month}.${normalizedDate.getFullYear()}`;
  }
}
